import React, { Dispatch, RefObject, SetStateAction, useEffect } from "react";
import { useSelector } from "react-redux";
import stylesPc from "./VideoPlayer.module.css";
import stylesSp from "./VideoPlayer_SP.module.css";
import styleIpad from "./VideoPlayer_IP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
// import VideoReactions from "./reactions/VideoReactions";
import CaptionsPanel from "./captions/CaptionsPanel";
import { Video } from "../../../../common/video/models/Video";
import EditVideoPage from "../../../../common/components/videoMenu/EditVideo";
import { ExtractExtention } from "../../../../utils/ObjectUtils";
import { AppState } from "../../../../root/RootReducer";
import { isAdmin, isEditor } from "../../../../utils/LogicUtils";
import { useInitText } from "../../../../components/function/useInitText";

interface VideoPageLiveAreaProps {
    video: Video;
    videoRef: RefObject<HTMLVideoElement>;
    currentVideoTimeMs: number;
    setEditModalOpen: (target: boolean) => void;
    setIsUnderlKeyBorardControl: Dispatch<SetStateAction<boolean>>;
}

function VideoPlayer({
    video,
    videoRef,
    currentVideoTimeMs,
    setEditModalOpen,
    setIsUnderlKeyBorardControl,
}: VideoPageLiveAreaProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : IsDevice("ipad") ? styleIpad : stylesSp;

    // ユーザー取得
    const { user } = useSelector((state: AppState) => ({
        user: state.user.user,
    }));

    const token = localStorage.getItem("cineonhub_access_token");
    // ビデオURL
    const sourceUrl =
        process.env.REACT_APP_API_ENDPOINT +
        video.sourceUrl +
        "/" +
        ExtractExtention(video.fileName) +
        "?Authorization=" +
        token;

    // 動画再生するURL
    const [currentUrl, setCurrentUrl] = useInitText();

    const videoDownloadControl = document.getElementById("videoPlayer");

    if (videoDownloadControl) {
        videoDownloadControl.oncontextmenu = function () {
            return false;
        };
    }
    useEffect(() => {
        if (currentUrl === "") {
            setCurrentUrl(sourceUrl);
        }
        // eslint-disable-next-line
    }, [sourceUrl]);

    if (!video) {
        return <div>Loading...</div>;
    }

    return (
        <div className={styles.videoArea}>
            <div className={styles.videoAndReactions}>
                <video
                    id="videoPlayer"
                    className={
                        videoRef.current &&
                        videoRef.current.videoWidth / videoRef.current.videoHeight >= 1
                            ? styles.LandscapeVideo
                            : styles.PortraitVideo
                    }
                    controls
                    autoPlay
                    width="100%"
                    ref={videoRef}
                    key={currentUrl} // Needed to inform React of source changes.
                    controlsList="nodownload"
                >
                    <source src={currentUrl} type="video/mp4" />
                    <track default={false} kind="subtitles" srcLang="ja" label="オン" />
                </video>

                {/*                 <VideoReactions
                    reactions={video.reactions}
                    videoId={video.id}
                    videoDuration={video.durationMillis}
                    videoRef={videoRef}
                /> */}
                {/* ビデオ編集ボタン */}
                {IsDevice("desktop") && (
                    <div className={styles.editVideoIcon}>
                        <EditVideoPage
                            videoId={video.id}
                            setEditModalOpen={setEditModalOpen}
                        />
                    </div>
                )}
            </div>
            {IsDevice("desktop") && (
                <div className={`${styles.caption} ${(isAdmin(user?.roles) || isEditor(user?.roles)) ? styles.isAdmin : ""}`}>
                    <CaptionsPanel
                        videoId={video.id}
                        captions={video.captions}
                        videoRef={videoRef}
                        currentVideoTimeMs={currentVideoTimeMs}
                        setEditModalOpen={setEditModalOpen}
                    />
                </div>
            )}
        </div>
    );
}

export default VideoPlayer;
